// extracted by mini-css-extract-plugin
module.exports = {"container":"profile-module--container--KroJB","profile":"profile-module--profile--39_kr","lang":"profile-module--lang--3OXwr"};